/**
 * Duplicator rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Your spellbook and atlas can only contain matching pairs of
 *    Uniques and you start with only two spells and two sites in hand.
 *    Tap → Play or draw a site."
 *
 * Two rules, two different homes:
 *
 *   1. "Start with only two spells and two sites in hand".
 *      opening-hand modifier, belongs here. Spellbook = 2, Atlas = 2.
 *
 *   2. "Your spellbook and atlas can only contain matching pairs of
 *      Uniques." A deckbuilding rule that rejects any deck whose
 *      Uniques aren't paired. Belongs in `src/utils/sorcery/deckRules.js`,
 *      not here.
 *
 * Mulligan cap stays at the default 3. Because Duplicator's opening
 * hand is only 4 cards total, the 3-card mulligan cap lets the player
 * dig through nearly their entire opener, which matches the rulebook.
 */
export const DUPLICATOR_RULES = {
  openingHand: {
    spellbook: 2,
    atlas: 2,
  },
  deckbuilding: {
    // "Only matching pairs of Uniques." Two whole-deck constraints:
    //   (1) every card in the deck must have rarity Unique
    //   (2) every Unique must appear in exactly matching pairs
    //       (two copies of the same printing, per the rulebook)
    //
    // These are whole-deck rules, not per-card-add rules, so they're
    // checked at save / match-entry time via validateDeckStructure
    // rather than inside canAddCard. The Editor can still flag violations
    // with a toast, but doesn't block intermediate editing.
    requireUniquesOnly: true,
    requirePairs: true,
  },
};
